<template>
  <div>
    <div class="header-block">
      <div class="d-flex justify-content-between">
        <div>Orientačný limit úveru podľa DTI</div>
        <div>
          <v-progress-circular
            v-if="dtiLoading"
            class="loading-spinner extrasmall"
            indeterminate
          ></v-progress-circular>
          <div class="bold" v-else>{{ estimatedDti?.value | dotTheAmount }} EUR</div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div>Akceptovaný príjem / mes.</div>
        <div>
          <v-progress-circular
            v-if="dtiLoading"
            class="loading-spinner extrasmall"
            indeterminate
          ></v-progress-circular>
          <div class="bold" v-else>{{ estimatedDti?.extra?.prijem_mo | dotTheAmount }} EUR</div>
        </div>
      </div>
      <div v-if="income?.error">
        <br>
        <div
          v-for="(error, key) in income.error"
          :key="key"
          class="error-text"
        >
          {{ error }}
        </div>
      </div>
    </div>
    <form @submit.prevent="saveIncome" id="income-submit">
      <div data-w-tab="Tab 1" class="w-tab-pane w--tab-active">
        <div class="w-form">
          <div class="employment-flow-heading">
            <span class="employment-flow-number">01</span>
            <div>
              <div class="employment-flow-title">Mesačný príjem</div>
              <div class="employment-flow-description">
                Zadajte posledné mesiace alebo použite rýchle vyplnenie priemerom.
              </div>
            </div>
          </div>
          <monthly-amount-input :averages="monthlyAmountAveragesFromInput" :init-months="form.monthlyIncomes" @refresh-dti="showEstimatedDtiToUser"/>
          <div class="average-income-grid">
            <div class="input-group">
              <label for="priemer-inc-6" class="field-label">
                Rýchlo vyplniť priemerom za 6 mesiacov
              </label>
              <input
                type="number"
                @change="calculateAverage($event, 6)"
                class="text-input w-input date-input"
                maxlength="256"
                name="priemer-inc-6"
                data-name="priemer-inc-6"
                id="priemer-inc-6"
              />
            </div>
            <div class="input-group">
              <label for="priemer-inc-12" class="field-label">
                Rýchlo vyplniť priemerom za 12 mesiacov
              </label>
              <input
                type="number"
                @change="calculateAverage($event, 12)"
                class="text-input w-input date-input"
                maxlength="256"
                name="priemer-inc-12"
                data-name="priemer-inc-12"
                id="priemer-inc-12"
              />
            </div>
          </div>

<!--          <monthly-amount-input :update-value="'diety'" :init-months="diety" @refresh-dti="showEstimatedDtiToUser"/>-->
          <!-- <div
            class="input-group"
          >
            <label for="priemer-die-6" class="field-label">
              Priemer diét za posledných 6 mesiacov
            </label>
            <input
              type="number"
              class="text-input w-input date-input"
              maxlength="256"
              name="priemer-die-6"
              data-name="priemer-die-6"
              id="priemer-die-6"
            />
          </div>
          <div
            class="input-group"
          >
            <label for="priemer-die-12" class="field-label">
              Priemer diét za posledných 12 mesiacov
            </label>
            <input
              type="number"
              class="text-input w-input date-input"
              maxlength="256"
              name="priemer-die-12"
              data-name="priemer-die-12"
              id="priemer-die-12"
            />
          </div> -->
          <div class="employment-flow-heading">
            <span class="employment-flow-number">02</span>
            <div>
              <div class="employment-flow-title">Pracovný pomer</div>
              <div class="employment-flow-description">
                Na prvý prepočet stačí približná dĺžka zamestnania. Presný dátum môžete doplniť neskôr.
              </div>
            </div>
          </div>
          <div class="dropdown-input-custom required">
            <input
              type="text"
              v-model="form.druh"
              style="opacity: 0; position: absolute"
              :required="required"
            />
            <dropdown-select
              @select="setDropdownValue($event, 'druh')"
              :id="'employment_druh'"
              :init-value="form.druh"
              :options="typeOfEmploymentSelect"
              normal
              :name="'Typ pracovného pomeru'"
            />
          </div>

          <div v-if="requiresEmploymentDuration" class="duration-mode-switch" role="tablist" aria-label="Spôsob zadania začiatku zamestnania">
            <button
              type="button"
              class="duration-mode-button"
              :class="{ active: form.durationMode === 'quick' }"
              :aria-selected="form.durationMode === 'quick'"
              @click="setDurationMode('quick')"
            >
              Rýchly prepočet
            </button>
            <button
              type="button"
              class="duration-mode-button"
              :class="{ active: form.durationMode === 'exact' }"
              :aria-selected="form.durationMode === 'exact'"
              @click="setDurationMode('exact')"
            >
              Presný dátum
            </button>
          </div>

          <div v-if="requiresEmploymentDuration && form.durationMode === 'quick'" class="duration-options">
            <button
              v-for="option in employmentDurationOptions"
              :key="option.value"
              type="button"
              class="duration-option"
              :class="{ active: form.durationCategory === option.value }"
              @click="setDurationCategory(option.value)"
            >
              <span class="duration-option-title">{{ option.label }}</span>
              <span class="duration-option-description">{{ option.description }}</span>
            </button>
            <div class="duration-hint">
              Výpočet v rozmedzí 3 až 6 mesiacov je nastavený konzervatívne. Banky, ktoré vyžadujú dlhšiu históriu, sa sprístupnia po zadaní presného dátumu.
            </div>
          </div>

          <div
            class="date-picker-wrapper"
            v-if="requiresEmploymentDuration && form.durationMode === 'exact'"
          >
            <div class="input-group">
              <label for="Zamestnan-od" class="field-label"
              >Zamestnaný <strong>od</strong></label
              ><input
              v-model="form.zamestnanyOd"
              type="date"
              :max="getTodayDate()"
              class="text-input w-input date-input required"
              maxlength="256"
              name="zamestnanyOd"
              data-name="Zamestnaný od"
              id="Zamestnan-od"
              :required="required"
            />
            </div>
          </div>
          <div
            class="date-picker-wrapper single-date"
            v-if="isFixedTerm"
          >
            <div class="input-group">
              <label for="Zamestnan-do" class="field-label"
              >Zamestnaný <strong>do</strong></label
              ><input
              v-model="form.zamestnanyDo"
              type="date"
              :min="getTodayDate()"
              class="text-input w-input date-input required"
              maxlength="256"
              name="zamestnanyDo"
              data-name="Zamestnaný do"
              id="Zamestnan-do"
              :required="required"
            />
            </div>
          </div>
          <div
            class="dropdown-input-custom rest-input"
            v-if="shortIncome"
          >
            <dropdown-select
              @select="setDropdownValue($event, 'dovodKratsejDobyPrijmu')"
              :id="'dovod_kratsej_doby_prijmu'"
              :init-value="form.dovodKratsejDobyPrijmu"
              :options="formTemplate.dovod_kratsej_doby_prijmu.choices"
              normal
              :name="'Dôvod kratšej doby príjmu'"
            />
          </div>
          <div class="text-input w-input date-input popup-input-wrapper">
            <div class="blc-color">Iné špecifiká príjmu</div>
            <client-employment-rest-handler :rules="['single']" :ostatne="restMultiselect"/>
          </div>
          <!--          <div-->
          <!--            class="dropdown-input-custom rest-input"-->
          <!--            style="margin-top: 17px"-->
          <!--          >-->
          <!--            <dropdown-select-->
          <!--              @select="setDropdownValue($event, 'ostatne')"-->
          <!--              :id="'employment_ostatne'"-->
          <!--              :init-value="form.ostatne"-->
          <!--              :options="restMultiselect"-->
          <!--              normal-->
          <!--              multiple-->
          <!--              :name="'Ostatné'"-->
          <!--            />-->
          <!--          </div>-->
          <div class="employment-flow-heading">
            <span class="employment-flow-number">03</span>
            <div>
              <div class="employment-flow-title">Zamestnávateľ (nepovinné)</div>
              <div class="employment-flow-description">
                Úver môžete vypočítať aj bez IČO a názvu zamestnávateľa. Údaje môžete doplniť neskôr.
              </div>
              <div v-if="!isForeignIncome" class="employment-flow-description">
                IČO automaticky doplní obchodný názov a sídlo. Údaje môžete overiť na
              <a class="link" href="https://www.finstat.sk/" target="_blank">finstat.sk</a>
              </div>
            </div>
          </div>
          <div
            v-if="isForeignIncome"
            class="dropdown-input-custom required foreign-country-field"
          >
            <input
              type="text"
              :value="form.country"
              style="opacity: 0; position: absolute"
              required
              tabindex="-1"
            />
            <dropdown-select
              @select="setEmploymentCountry"
              :id="'employment_country'"
              :init-value="form.country"
              :options="formTemplate.address_country.choices"
              normal
              required
              :name="'Krajina zamestnania'"
            />
            <div class="employment-flow-description foreign-income-hint">
              Krajina a mena rozhodujú o tom, ktoré banky príjem akceptujú.
            </div>
          </div>
          <div
            class="input-group"
          >
            <label for="Typ-pr-jmu-2" class="field-label" v-if="!restMultiselect[4].value">
              IČO <span class="pop-300">(nepovinné, údaje sa doplnia automaticky)</span>
            </label>
            <label for="Typ-pr-jmu-2" class="field-label" v-else>
              ID spoločnosti <span class="pop-300">(nepovinné)</span>
            </label>
            <input
              @change="initializeEmployer"
              v-model="ico"
              :readonly="!sidloInputNeed"
              type="text"
              class="text-input w-input"
              :maxlength="isForeignIncome ? 64 : 8"
              :minlength="isForeignIncome ? null : 8"
              name="icoZamestnavatel"
              data-name="Typ Pr Jmu 2"
              placeholder=""
              id="Typ-pr-jmu-2"
            />
          </div>
          <div class="input-group">
            <label for="obchodny-nazov" class="field-label"
            >Obchodný názov <span class="pop-300">(nepovinné)</span></label
            ><input
            v-model="employerDetail.name"
            :readonly="!isForeignIncome || !sidloInputNeed"
            type="text"
            class="text-input w-input"
            :class="{'input-color-disabled': !isForeignIncome}"
            maxlength="256"
            name="obchodny-nazov"
            data-name="obchodny-nazov"
            placeholder=""
            id="obchodny-nazov"
          />
          </div>
          <div v-if="isForeignIncome">
            <sidlo-input
              v-if="sidloInputNeed"
              @address-change="setAddress($event)"
              :type="'house'"
            />
            <div class="input-group" v-else>
              <label class="field-label">Sídlo</label
              ><input
              v-model="sidloInputFormattedValue"
              readonly
              type="text"
              class="text-input w-input"
              maxlength="256"
              name="sidlo"
              data-name="sidlo"
              placeholder=""
              id="sidlo"
            />
            </div>
          </div>
          <div class="input-group" v-else>
            <label class="field-label">Sídlo</label
            ><input
            v-model="
                employerDetail.slovensko_digital_response.formatted_address
              "
            :readonly="!restMultiselect[4].value"
            type="text"
            class="text-input w-input"
            :class="{'input-color-disabled': !restMultiselect[4].value}"
            maxlength="256"
            name="sidlo"
            data-name="sidlo"
            placeholder=""
            id="sidlo"
          />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DropdownSelect from "../../../DropdownSelect";
import {
  createEmployer,
  deleteMonthlyIncome,
  getEmployerByIco,
  getEmploymentDTI,
  patchMonthlyIncome,
  postMonthlyIncome,
} from "@/services/brokerService";
import ClientEmploymentDietyHandler from "../ClientEmploymentDiety/ClientEmploymentDietyHandler";
import ClientEmploymentRestHandler from "../ClientEmploymentRest/ClientEmploymentRestHandler";
import SidloInput from "../../../SidloInput";
import MonthlyAmountInput from "@/components/shared/PopupHandler/Popups/ClientIncomes/MonthlyAmountInput.vue";

export default {
  name: "EmploymentForm",
  components: {
    MonthlyAmountInput,
    SidloInput,
    ClientEmploymentRestHandler,
    ClientEmploymentDietyHandler,
    DropdownSelect
  },
  props: {
    employmentDefined: Boolean,
    income: [Object, null],
    formTemplate: Object,
    metaData: [Object, null],
  },
  watch: {
    income(updatedIncome) {
      const employer = updatedIncome?.zamestnavatel;
      if (!employer) {
        this.resetEmployer();
        this.ico = null;
      } else if (typeof employer === "object") {
        this.employerDetail = {
          ...employer,
          slovensko_digital_response: employer.slovensko_digital_response || {formatted_address: null},
        };
        this.ico = employer.ico;
      }
    },
    'form.zamestnanyOd'(newFrom) {
      if (this.form.durationMode !== "exact" || !newFrom) return;
      this.updateShortIncomeFromExactDate();
    },
    metaData(meta) {
      if (meta.hasOwnProperty("diety")) {
        this.diety = meta.diety;
        this.mergeDietsToMonthlyIncomes();
      } else if (meta.hasOwnProperty("rest")) {
        this.restMultiselect = meta.rest;
      }
    }
  },
  created() {
    this.restMultiselect[4].dropdownValue.choices = this.formTemplate.mena.choices;
    if (this.income) {
      this.form.druh = this.income.druh;
      this.form.zamestnanyOd = this.income.zamestnanie_od;
      this.form.zamestnanyDo = this.income.zamestnanie_do;
      const savedDurationCategory = this.income.meta?.employment_duration_category;
      if (savedDurationCategory) {
        this.form.durationMode = "quick";
        this.form.durationCategory = savedDurationCategory;
        this.updateApproximateEmploymentDate();
      } else {
        this.form.durationMode = "exact";
        this.updateShortIncomeFromExactDate();
      }
      this.form.pracovneZaradenie = this.income.pracovne_zaradenie;
      this.form.profesia = this.income.profesia;
      this.form.monthlyIncomes = [...this.income.mesacne_prijmy];
      this.form.monthlyIncomes = this.sortIncomes(this.form.monthlyIncomes);
      // this.splitMonthlyIncomes(this.income.mesacne_prijmy);
      this.fillEmptyDateBlocks(this.form.monthlyIncomes);
      // this.fillEmptyDateBlocks(this.diety);
      this.form.mena = this.income.mena;
      this.form.country = this.income.address_country || this.income.zamestnavatel?.address_country || null;
      this.setOstatne();
      if (this.income.zamestnavatel && typeof this.income.zamestnavatel === "object") {
        const empl = this.income.zamestnavatel;
        this.employerDetail.name = empl.name;
        this.employerDetail.id = empl.id;
        this.ico = empl.ico;
        for (const key of Object.keys(this.employerAddress)) {
          this.employerAddress[key] = empl[key] ?? this.employerAddress[key];
        }
        if (empl.slovensko_digital_response) {
          this.employerDetail.slovensko_digital_response.formatted_address =
            empl.slovensko_digital_response.formatted_address;
        } else {
          this.sidloInputNeed = false;
          this.sidloInputFormattedValue = `${empl.address_street} ${empl.address_popisne}, ${empl.address_city} ${empl.address_zip}`;
        }
      }
      this.form.odvetvie = this.income.zamestnavatel_odvetvie;
      if (!["pracovny_pomer_na_neurcito", "pracovny_pomer_na_cas_urcity"].includes(this.form.druh)) {
        this.form.dovodKratsejDobyPrijmu = null;
      } else {
        this.form.dovodKratsejDobyPrijmu = this.income.dovod_kratsej_doby_prijmu;
      }
      this.showEstimatedDtiToUser();
    } else {
      this.fillEmptyDateBlocks(this.form.monthlyIncomes);
    }
  },
  data: () => ({
    preparingIncome: false,
    monthlyAmountAveragesFromInput: null,
    required: true,
    dtiLoading: false,
    sidloInputNeed: true,
    sidloInputFormattedValue: null,
    employerAddress: {
      address_country: null,
      address_county: null,
      address_district: null,
      address_city: null,
      address_street: null,
      address_number: null,
      address_popisne: null,
      address_zip: null,
    },
    form: {
      druh: null,
      zamestnanyOd: null,
      zamestnanyDo: null,
      durationMode: "quick",
      durationCategory: "over_6_months",
      pracovneZaradenie: null,
      ostatne: [],
      odvetvie: null,
      profesia: null,
      monthlyIncomes: [],
      mena: null,
      country: null,
      dovodKratsejDobyPrijmu: null,
    },
    employerDetail: {
      name: null,
      id: null,
      slovensko_digital_response: {
        formatted_address: null,
      },
    },
    shortIncome: false,
    // diety: [],
    // monthlyIncomesMerged: [],
    ico: null,
    estimatedDti: null,
    employmentDurationOptions: [
      {
        label: "Menej ako 3 mesiace",
        description: "Príjem bude pre väčšinu bánk problémový.",
        value: "under_3_months",
      },
      {
        label: "3 až 6 mesiacov",
        description: "Použije sa konzervatívne minimum nad 3 mesiace.",
        value: "between_3_and_6_months",
      },
      {
        label: "Viac ako 6 mesiacov",
        description: "Dostatočná história pre bežný prvý prepočet.",
        value: "over_6_months",
      },
    ],
    typeOfEmploymentSelect: [
      {
        display_name: "pracovný pomer na určito",
        value: "pracovny_pomer_na_cas_urcity",
      },
      {
        display_name: "pracovný pomer na neurčito",
        value: "pracovny_pomer_na_neurcito",
      },
      {
        display_name: "dohoda o pracovnej činnosti",
        value: "dohoda_o_pracovnej_cinnosti",
      },
      {
        display_name: "pracovný pomer vo vlastnej firme",
        value: "pracovny_pomer_vo_vlastnej_firme",
      },
      // {
      //   display_name: "pracovný pomer cez agentúru",
      //   value: "pracovny_pomer_cez_agenturu",
      // },
    ],
    restMultiselect: [
      {
        display_name: "prechod zo živnosti na zamestnanie",
        value: false,
        dbProperty: "prechod_zivnost_tpp_poslednych_6m",
      },
      {
        display_name: "výpovedná skúšobná doba",
        value: false,
        dbProperty: "vypovedna_skusobna_doba",
      },
      {
        display_name: "zastupovanie na materskej",
        value: false,
        dbProperty: "zastupovanie_na_materskej",
      },
      {
        display_name: "obnovená pracovná zmluva",
        value: false,
        dbProperty: "zmluva_obnovena",
      },
      {
        display_name: "zahraničný príjem",
        value: false,
        dbProperty: "mena",
        dropdownValue: {
          id: 'mena',
          title: 'Mena',
          choices: null,
          default: "EUR",
          value: null,
        }
      },
    ],
    firstTime: true,
    date: new Date().toISOString().substr(0, 10),
    max: new Date().toISOString().substr(0, 10),
  }),
  computed: {
    isForeignIncome() {
      return Boolean(this.restMultiselect[4]?.value);
    },
    requiresEmploymentDuration() {
      return [
        "pracovny_pomer_na_neurcito",
        "pracovny_pomer_na_cas_urcity",
      ].includes(this.form.druh);
    },
    isFixedTerm() {
      return this.form.druh === "pracovny_pomer_na_cas_urcity";
    },
  },
  methods: {
    setDurationMode(mode) {
      if (this.form.durationMode === mode) return;
      this.form.durationMode = mode;
      if (mode === "quick") {
        this.updateApproximateEmploymentDate();
      } else {
        this.form.zamestnanyOd = null;
        this.shortIncome = false;
      }
    },
    setDurationCategory(category) {
      this.form.durationCategory = category;
      this.updateApproximateEmploymentDate();
    },
    updateApproximateEmploymentDate() {
      const daysByCategory = {
        under_3_months: 30,
        between_3_and_6_months: 91,
        over_6_months: 190,
      };
      const daysAgo = daysByCategory[this.form.durationCategory] || 190;
      const approximateDate = new Date();
      approximateDate.setDate(approximateDate.getDate() - daysAgo);
      this.form.zamestnanyOd = approximateDate.toISOString().slice(0, 10);
      this.shortIncome = this.form.durationCategory !== "over_6_months";
    },
    updateShortIncomeFromExactDate() {
      if (!this.form.zamestnanyOd) {
        this.shortIncome = false;
        return;
      }
      const fromDate = new Date(this.form.zamestnanyOd);
      const differenceMonths = this.monthDiff(fromDate, new Date());
      this.shortIncome = differenceMonths < 6;
    },
    calculateAverage(event, months) {
      this.monthlyAmountAveragesFromInput = {
        amount: event.target.valueAsNumber,
        months,
      };
    },
    setAddress(addressObject) {
      this.employerAddress.address_country = addressObject.address_text_country;
      this.employerAddress.address_county = addressObject.address_text_county;
      this.employerAddress.address_district = addressObject.address_text_district;
      this.employerAddress.address_city = addressObject.address_text_city;
      this.employerAddress.address_street = addressObject.address_text_street;
      this.employerAddress.address_number = addressObject.address_text_number;
      this.employerAddress.address_popisne = addressObject.address_text_popisne;
      this.employerAddress.address_zip = addressObject.address_text_zip;
    },
    setEmploymentCountry(country) {
      this.form.country = country;
      this.employerAddress.address_country = country;
    },
    monthDiff(d1, d2) {
      let months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    // checkForShortIncomeDuration(employeeFrom) {
    //   console.log(employeeFrom);
    //   if (!employeeFrom) return;
    //   const currentMonth = new Date().getMonth() + 1;
    //   const selectedMonth = parseInt(employeeFrom.substr(5, 6));
    //   this.shortIncome = monthDiff(currentMonth,) < 3;
    // },
    sortIncomes(objects, desc=false) {
      return objects.sort(function(a, b) {
        const yearA = a.rok;
        const monthA = a.mesiac;
        const yearB = b.rok;
        const monthB = b.mesiac;
        const dateA = new Date(yearA, monthA);
        const dateB = new Date(yearB, monthB);
        if (desc) return dateA - dateB
        return dateB - dateA;
      });
    },


    fillEmptyDateBlocks(pDateBlocks) {
      const currentDate = new Date();
      let dateBlocks = pDateBlocks;

      if (dateBlocks.length === 0) {
        // Set the first date block to the previous month
        let previousMonth = currentDate.getMonth(); // 0-indexed, so no +1
        let year = currentDate.getFullYear();

        if (previousMonth === 0) {
          previousMonth = 12; // Wrap to December
          year -= 1;
        }

        const dateObject = {
          income: null,
          mesiac: previousMonth, // Adjust for 1-based indexing in your system if needed
          rok: year,
          diety: 0,
          suma: null,
        };

        dateBlocks.push(dateObject);
      }

      // Fill missing months and ensure blocks meet the required number
      this.fillLastMissingMonth(dateBlocks, currentDate);

      if (dateBlocks.length < 3) {
        this.fillMissingToLimit(dateBlocks, 3 - dateBlocks.length);
        return;
      }

      this.checkForMissingBlocks(dateBlocks);
    },

    
    fillMissingToLimit(dateBlocks, missing) {
      const latest = dateBlocks[dateBlocks.length - 1];
      let currentMonth = latest.mesiac;
      let currentYear = latest.rok;

      console.log("Starting from:", currentMonth, currentYear);

      for (let i = 0; i < missing; i++) {
        // Decrease the month by 1
        currentMonth--;

        // Adjust for the case when currentMonth is less than 1 (January -> December)
        if (currentMonth < 1) {
          currentMonth = 12;
          currentYear--;
        }

        console.log(`Adding: Month ${currentMonth}, Year ${currentYear}`);

        // Add the new date block for the calculated month and year
        dateBlocks.push({
          income: latest.income,
          mesiac: currentMonth,
          rok: currentYear,
          diety: 0,
          suma: null,
        });
      }
    },

    fillLastMissingMonth(dateBlocks, currentDate) {
      const firstBlock = dateBlocks[0];
      console.log(firstBlock);
      // je oktorber 2024, chyba mi prijem za December ktory sa ma vypytat
      
      // ked je aktualny mesiac vacsi ako posledny prijem a sucasne je rok vacsi ako rok posledneho prijmu 
      if (currentDate.getMonth() > firstBlock.mesiac || currentDate.getFullYear() > firstBlock.rok) {
        let lastMonth = firstBlock.mesiac;
        let lastYear = firstBlock.rok;
        console.log(lastMonth, lastYear);
        
        // Check if the current month is January and we need to roll back to December
        if (currentDate.getMonth() === 0 && lastMonth === 11) {
          lastMonth = 11; // Correctly set to December (0-indexed)
          lastYear--;
        }
      }
    },
    checkForMissingBlocks(dateBlocks) {
        if (!Array.isArray(dateBlocks) || dateBlocks.some(block => typeof block.mesiac !== 'number' || typeof block.rok !== 'number')) {
            console.error("Invalid dateBlocks structure:", dateBlocks);
            return;
        }

        for (let index = 0; index < dateBlocks.length - 1; index++) {
            const current = dateBlocks[index];
            const next = dateBlocks[index + 1];

            const currentMonth = current.mesiac;
            const nextMonth = next.mesiac;
            const currentYear = current.rok;
            const nextYear = next.rok;

            // Skip if no gap
            if (currentYear === nextYear && currentMonth === nextMonth - 1) {
                continue;
            } else if (currentYear === nextYear - 1 && currentMonth === 12 && nextMonth === 1) {
                continue;
            }

            const missingMonths = this.getMissingMonths(current, next);
            missingMonths.forEach((monthData) => {
                dateBlocks.splice(index + 1, 0, monthData);
                index++; // Skip past the new entry
            });
        }
    },

    getMissingMonths(startDate, endDate) {
      const maxIterations = 1000; // Prevent infinite loops
      let missingMonths = [];
      let iterationCount = 0;

      if (!startDate || !endDate) {
        console.error("Invalid start or end date:", startDate, endDate);
        return [];
      }

      // Ensure dates are in the correct order
      if (startDate > endDate) {
        console.error("Start date is after end date:", startDate, endDate);
        return [];
      }

      let current = new Date(startDate);
      const end = new Date(endDate);

      while (current <= end) {
        // Check for excessive iterations
        if (iterationCount > maxIterations) {
          console.error(
            `Max iterations reached in getMissingMonths. Start: ${startDate}, End: ${endDate}.`
          );
          return [];
        }

        missingMonths.push(new Date(current)); // Add current month to the list
        current.setMonth(current.getMonth() + 1); // Move to the next month
        iterationCount++;
      }

      return missingMonths;
    },


    splitMonthlyIncomes(incomes) {
      const copyOfIncomes = JSON.parse(
        JSON.stringify(incomes)
      ).reverse();
      for (const copyOfIncome of copyOfIncomes) {
        if (copyOfIncome.suma !== 0) {
          const suma = {...copyOfIncome};
          suma.diety = 0;
          suma.automated = false;
          this.form.monthlyIncomes.push(suma);
        }
        if (copyOfIncome.diety !== 0) {
          const dieta = {...copyOfIncome};
          dieta.suma = 0;
          this.diety.push(dieta);
        }
      }
    },
    mergeDietsToMonthlyIncomes() {
      const copyOfMonthlyIncomes = JSON.parse(
        JSON.stringify(this.form.monthlyIncomes)
      );
      for (const copyOfMonthlyIncome of copyOfMonthlyIncomes) {
        copyOfMonthlyIncome.diety = 0;
      }
      for (const dieta of this.diety) {
        for (const [index, monthlyIncome] of copyOfMonthlyIncomes.entries()) {
          if (dieta.mesiac === monthlyIncome.mesiac && dieta.rok === monthlyIncome.rok) {
            dieta.dietyOnly = false;
            monthlyIncome.diety = dieta.diety;
            break;
          }
          if (index === copyOfMonthlyIncomes.length - 1) {
            dieta.dietyOnly = true;
            copyOfMonthlyIncomes.push(dieta);
            break;
          }
        }
      }
      this.monthlyIncomesMerged = copyOfMonthlyIncomes;
    },
    setOstatne() {
      if (this.income.prechod_zivnost_tpp_poslednych_6m) {
        this.restMultiselect[0].value = true;
      }
      if (this.income.vypovedna_skusobna_doba) {
        this.restMultiselect[1].value = true;
      }
      if (this.income.zastupovanie_na_materskej) {
        this.restMultiselect[2].value = true;
      }
      if (this.income.zmluva_obnovena) {
        this.restMultiselect[3].value = true;
      }
      if (
        this.income.prijem_zo_zahranicia
        || (this.income.address_country && this.income.address_country !== "SK")
        || this.income.mena !== "EUR"
      ) {
        this.restMultiselect[4].value = true;
        this.restMultiselect[4].dropdownValue.value = this.income.mena;
      }
    },
    resetEmployer() {
      this.sidloInputNeed = true;
      this.sidloInputFormattedValue = null;
      this.employerDetail = {
        id: null,
        name: null,
        slovensko_digital_response: {formatted_address: null},
      };
    },
    async initializeEmployer() {
      if (this.restMultiselect[4].value) {
        return;
      }
      const requestedIco = (this.ico || "").trim();
      if (!requestedIco) {
        this.resetEmployer();
      } else {
        try {
          const employer = await getEmployerByIco({ico: requestedIco});
          if ((this.ico || "").trim() !== requestedIco) return;
          this.employerDetail = employer;
        } catch (e) {
          if ((this.ico || "").trim() !== requestedIco) return;
          this.resetEmployer();
          this.$store.commit("appState/setSuccessMessage", {
            text: "Zamestnávateľ podľa iča nebol nájdený",
            type: "error"
          });
        }
      }
    },
    async showEstimatedDtiToUser() {
      this.dtiLoading = true;
      const arrayOfMonthlyIncomeAmount = this.getArrayOfMonthlyIncomesAmount();
      this.estimatedDti = null;
      const dtiInfo = await getEmploymentDTI(arrayOfMonthlyIncomeAmount);
      let dtiValue = 0;
      for (const value of Object.entries(dtiInfo)) {
        for (const valueElement of value) {
          if (this.estimatedDti < valueElement.value) {
            dtiValue = Math.round(valueElement.value);
            this.estimatedDti = valueElement;
          }
        }
      }
      this.dtiLoading = false;
    },
    getArrayOfMonthlyIncomesAmount() {
      let arrayOfAmounts = [];
      for (const income of this.form.monthlyIncomes) {
        arrayOfAmounts.push({suma: income.suma ? income.suma : 0});
      }
      return arrayOfAmounts;
    },
    setDropdownValue(value, dropdownName) {
      if (dropdownName === "druh") {
        if (!this.firstTime) {
          this.form.zamestnanyDo = null;
          if (this.form.durationMode === "exact") {
            this.form.zamestnanyOd = null;
          }
        }
        this.firstTime = false;
      }
      this.form[dropdownName] = value;
      if (dropdownName === "druh") {
        if (this.requiresEmploymentDuration && this.form.durationMode === "quick") {
          this.updateApproximateEmploymentDate();
        } else if (!this.requiresEmploymentDuration) {
          this.form.zamestnanyOd = null;
          this.form.zamestnanyDo = null;
          this.shortIncome = false;
        }
      }
    },
    translateDateFromDbValue(dateToTransform) {
      if (!dateToTransform) return null;
      let dateArray = dateToTransform.split("-");
      dateArray.pop();
      return dateArray.join("-");
    },
    mergeRestToIncome(incomeObject) {
      for (const restValue of this.restMultiselect) {
        if (restValue.hasOwnProperty("dropdownValue")) {
          incomeObject[restValue.dbProperty] = restValue.value
            ? (restValue.dropdownValue.value || restValue.dropdownValue.default)
            : restValue.dropdownValue.default;
        } else {
          incomeObject[restValue.dbProperty] = restValue.value;
        }
      }
    },
    async getEmployerId() {
      if (this.isForeignIncome) {
        if (!(this.employerDetail.name || "").trim() && !(this.ico || "").trim()) {
          return null;
        }
        const employerObject = {
          ico: this.ico || null,
          name: (this.employerDetail.name || "").trim(),
          ...this.employerAddress,
          stat_registracie: this.form.country,
          address_country: this.form.country
        }
        const employer = await createEmployer(employerObject);
        // console.log(employer);
        return employer.id;
      }
      return this.employerDetail?.id || null;
    },
    async saveIncome() {
      if (this.preparingIncome) return;
      this.preparingIncome = true;
      this.$emit('income-preparing', true);
      this.$emit('income-save-error', '');
      try {
        const incomeMeta = {...(this.income?.meta || {})};
        if (this.requiresEmploymentDuration && this.form.durationMode === "quick") {
          incomeMeta.employment_duration_category = this.form.durationCategory;
        } else {
          delete incomeMeta.employment_duration_category;
        }
        let incomeObject = {
          typ: "hlavny",
          druh: this.form.druh,
          zamestnanie_od: this.form.zamestnanyOd,
          zamestnanie_do: this.form.zamestnanyDo,
          zamestnanie_od_set_by_user: this.requiresEmploymentDuration && this.form.durationMode === "exact",
          meta: incomeMeta,
          profesia: this.form.profesia,
          pracovne_zaradenie: this.form.pracovneZaradenie,
          zamestnavatel_odvetvie: this.form.odvetvie,
          zamestnavatel: await this.getEmployerId(),
          prijem_zo_zahranicia: this.isForeignIncome,
          address_country: this.isForeignIncome ? this.form.country : "SK",
          dovod_kratsej_doby_prijmu: this.shortIncome ? this.form.dovodKratsejDobyPrijmu : null,
        };
        this.mergeRestToIncome(incomeObject);
        // this.mergeDietsToMonthlyIncomes();
        if (this.income) {
          incomeObject.id = this.income.id;
          incomeObject.mesacne_prijmy = await this.handleMonthIncomesChange();
        }
        this.$emit("income-saved", {
          incomeInfo: incomeObject,
          monthlyIncomes: this.form.monthlyIncomes,
          employer: this.employerDetail?.id ? {...this.employerDetail} : null,
        });
      } catch (error) {
        this.$emit('income-save-error', 'Údaje príjmu sa nepodarilo uložiť. Skontrolujte pripojenie a skúste to znova.');
      } finally {
        this.preparingIncome = false;
        this.$emit('income-preparing', false);
      }
    },
    async handleMonthIncomesChange() {
      let oldMonthIncomes = JSON.parse(
        JSON.stringify(this.income.mesacne_prijmy)
      );
      for (const monthIncomeOld of this.form.monthlyIncomes) {
        for (const [index, monthIncomeNew] of oldMonthIncomes.entries()) {
          if (monthIncomeOld.id === monthIncomeNew.id) {
            oldMonthIncomes.splice(index, 1);
          }
        }
      }
      for (const oldMonthIncome of oldMonthIncomes) {
        await deleteMonthlyIncome(oldMonthIncome.id);
      }

      // const areInDecrementalOrder = this.isDecrementalDateOrder(this.form.monthlyIncomes);
      //
      // console.log(areInDecrementalOrder);
      //
      // if (!areInDecrementalOrder) {
      //   for (const income of this.form.monthlyIncomes) {
      //     if (income.id) {
      //       await deleteMonthlyIncome(income.id);
      //     }
      //     delete income.id;
      //   }
      // }
      //
      // this.form.monthlyIncomes = this.sortIncomes(this.form.monthlyIncomes, true);
      // console.log(this.form.monthlyIncomes);

      const monthlyIncomes = [];
      for (const monthIncome of this.form.monthlyIncomes) {
        if (!monthIncome.id) {
          monthIncome.income = this.income.id;
          const monthIncomeObject = await postMonthlyIncome(monthIncome);
          monthlyIncomes.push(monthIncomeObject);
        } else if (monthIncome.id && !monthIncome.automated) {
          const monthIncomeObject = await patchMonthlyIncome(monthIncome, monthIncome.id);
          monthlyIncomes.push(monthIncomeObject);
        }
      }
      return monthlyIncomes;
    },
    isDecrementalDateOrder(incomes) {
      for (let i = 1; i < incomes.length; i++) {
        const prev = incomes[i - 1];
        const curr = incomes[i];

        if (
          curr.rok < prev.rok ||
          (curr.rok === prev.rok && curr.mesiac < prev.mesiac)
        ) {
          return false;
        }
      }
      return true;
    },
    addMonth () {
      const incomeDate = this.getNextIncomeDate();
      const incomeMonth = {
        automated: false,
        income: null,
        id: null,
        mesiac: incomeDate.mesiac,
        rok: incomeDate.rok,
        suma: null,
        diety: 0,
      };
      this.form.monthlyIncomes.push(incomeMonth);
    },
    getMonth() {
      const incomeDate = this.getNextIncomeDate();
      return {
        automated: false,
        income: null,
        id: null,
        mesiac: incomeDate.mesiac,
        rok: incomeDate.rok,
        suma: 0,
        diety: 0,
      };
    },
    getNextIncomeDate() {
      const lastMonthInArray =
        this.form.monthlyIncomes[this.form.monthlyIncomes.length - 1].mesiac;
      const lastYearInArray =
        this.form.monthlyIncomes[this.form.monthlyIncomes.length - 1].rok;
      if (lastMonthInArray === 1) {
        return {
          mesiac: 12,
          rok: lastYearInArray - 1,
        };
      } else {
        return {
          mesiac: lastMonthInArray - 1,
          rok: lastYearInArray,
        };
      }
    },
    getTodayDate() {
      const today = new Date();
      const dd = today.getDate();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      return yyyy + "-" + mm + "-" + (dd < 10 ? `0${dd}` : dd);
    },
    getJobClass(e) {
      switch (e) {
        case "top_management":
          return "Top manažment";
        case "stredny_management":
          return "Stredný manažment";
        case "ostatni_zamestnanci":
          return "Ostatní zamestnanci";
        default:
          return null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.foreign-country-field {
  margin: 18px 0 8px;
}

.foreign-income-hint {
  margin-top: 8px;
}

input[type=month]::-webkit-input-placeholder {
  display: none;
}

.error-custom {
  font-size: 12px;
  padding-left: 15px;
  color: red;
}

.invalid-input {
  border: 1px solid red;
}

.employment-flow-heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin: 34px 0 18px;
  color: var(--app-text, #0a1953);
}

.employment-flow-number {
  display: inline-flex;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  border-radius: 13px;
  background: var(--app-primary-soft, rgba(45, 125, 210, 0.12));
  color: var(--app-primary, #2d7dd2) !important;
  -webkit-text-fill-color: var(--app-primary, #2d7dd2) !important;
  font-size: 13px;
  font-weight: 800;
}

.employment-flow-title {
  margin-top: 1px;
  color: var(--app-text, #0a1953) !important;
  -webkit-text-fill-color: var(--app-text, #0a1953) !important;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.25;
}

.employment-flow-description {
  max-width: 560px;
  margin-top: 4px;
  color: var(--app-text-muted, #6f7f96) !important;
  -webkit-text-fill-color: var(--app-text-muted, #6f7f96) !important;
  font-size: 14px;
  line-height: 1.45;
}

.average-income-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.duration-mode-switch {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin: 12px 0;
  padding: 6px;
  border: 1px solid var(--app-border, rgba(45, 125, 210, 0.16));
  border-radius: 18px;
  background: var(--app-surface-muted, #f4f8fc);
}

.duration-mode-button,
.duration-option {
  appearance: none;
  border: 1px solid transparent;
  color: var(--app-text, #0a1953);
  font: inherit;
  cursor: pointer;
}

.duration-mode-button {
  min-height: 50px;
  padding: 10px 14px;
  border-radius: 13px;
  background: transparent;
  color: var(--app-text-muted, #6f7f96);
  font-size: 14px;
  font-weight: 700;
}

.duration-mode-button:hover,
.duration-mode-button:focus-visible {
  color: var(--app-primary, #2d7dd2);
}

.duration-mode-button.active {
  border-color: var(--app-border, rgba(45, 125, 210, 0.16));
  background: var(--app-surface, #fff);
  box-shadow: var(--app-shadow, 0 8px 24px rgba(10, 25, 83, 0.06));
  color: var(--app-text, #0a1953);
}

.duration-options {
  display: grid;
  gap: 9px;
  margin-bottom: 14px;
}

.duration-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  min-height: 74px;
  padding: 15px 18px;
  border-color: var(--app-border, rgba(45, 125, 210, 0.16));
  border-radius: 17px;
  background: var(--app-surface, #fff);
  text-align: left;
  transition: border-color 0.16s ease, background-color 0.16s ease;
}

.duration-option:hover,
.duration-option:focus-visible {
  border-color: var(--app-primary, #2d7dd2);
}

.duration-option.active {
  border-color: var(--app-primary, #2d7dd2);
  background: var(--app-primary-soft, rgba(45, 125, 210, 0.12));
}

.duration-option-title {
  color: var(--app-text, #0a1953);
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
}

.duration-option-description {
  margin-top: 3px;
  color: var(--app-text-muted, #6f7f96);
  font-size: 13px;
  line-height: 1.4;
}

.duration-hint {
  padding: 12px 14px;
  border-radius: 13px;
  background: var(--app-surface-muted, #f4f8fc);
  color: var(--app-text-muted, #6f7f96);
  font-size: 12px;
  line-height: 1.45;
}

.date-picker-wrapper {
  margin-top: 6px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.dropdown-margin {
  margin-bottom: 20px;
}

input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.rest-input {
  margin-top: 10px;
}

.datepicker-wrapper {
  border-radius: 5px;
  position: absolute;
  width: 75%;
  z-index: 2;
  left: 60px;
  border: 1px solid black;
}

.datepicker-item {
  margin: 0 !important;
  z-index: 1;
}

.date-input:hover {
  cursor: pointer;
}

.popup-input-wrapper {
  padding: 15px 20px 15px 20px;
}

@media (max-width: 640px) {
  .average-income-grid,
  .duration-mode-switch {
    grid-template-columns: 1fr;
  }

  .employment-flow-heading {
    margin-top: 28px;
  }
}

//.checkbox-employment-type >>> label {
//  color: black;
//  line-height: 1.5;
//  font-size: 13px;
//}
</style>
